module.exports = __webpack_public_path__ + "static/media/cart.9de89d34.svg";